import React, { useEffect, useState } from 'react';
// import Card from '@mui/material/Card';
import swal from "sweetalert";
import { useHistory, useLocation, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
// import Button from '@mui/material/Button';
import dayjs from "dayjs";
import { toast } from 'react-toastify';
import { motion } from "framer-motion";

import "./../../WorkSpace/SignUp2.css";
import "./../../Bookclosure/Styles/Bookclosure.css";
// import { Navbar } from '../../Components/Navbar';
import SideBarv2 from '../../WorkSpace/Workspace-v2/Sidbarv2';
import {
    addLedgerToTask,
    addTask,
    approveTask,
    getApproverUserOptions,
    getOneBookClosure,
    getOneTask,
    returnTask,
    saveAndSubmitTask,
    submitTask,
    updateLedgerInTask,
    updateTask,
    addAssetsReconcillations,
    updateAssetsReconcillations,
    deleteAssetsReconcillations,
    getERPPullRequests,
    getBookClosureColumns,
    getBookClosureColumnsApiHandler,
    addBookClosureColumnsApiHandler,
    getBookClosureAddColumnDataApiHandler,
    syncERPData,
    updateTaskAttachments,
    deleteTask,
    restoreTasks
} from '../Services/ApiHandler';
import { getProfile } from '../../services/api/apiHandler';
import BookClosureProgressCard from '../Components/BookClosureProgressCard';
import TaskSVGComponent from '../Components/SvgComponents/BookClosureTask';
import TaskCompletedSvgComponent from '../Components/SvgComponents/TaskCompletedSvgComponent';
import TaskProgressSvgComponent from '../Components/SvgComponents/TaskProgressSvgComponent';
import CheckFieldDialog from '../Components/CheckFieldDialog';
import AddTaskModal from '../Components/AddTaskModal';
import LeaseModal from '../Components/LeaseModal';
import GLReceivableModal from '../Components/GLReceivableModal';
import BookClosureTaskList from '../Components/BookClosureTaskList';
import { clearLedgersViewMoreTask, getLedgersViewMoreTask, setAddedLedgers, setAdjustments, setBCCompany, setIsAddToTackModalOpen, setIsEditLedgerModal, setTaskComments } from '../../redux/actions/BookClosure/actionBookClosure';
import Select from "react-select";
import Loading from '../../Components/Common/Loader/Loading';
import BookClosureModuleTasks from '../Components/BookClosureModuleTasks';

import Sidebar from "../../myfin_v2/elements/Sidebar"
import commoncss from "../../myfin_v2/css/common.module.css"
import buttoncss from "../../myfin_v2/css/button.module.css";
import bookclosurecss from "../../myfin_v2/css/bookclosure.module.css";
import modalcss from "../../myfin_v2/css/modal.module.css";
import { DisplayCard } from "../../myfin_v2/elements/DisplayCards";
import StatusIndicator from "../../myfin_v2/elements/StatusIndicator";
import { Button } from "../../myfin_v2/elements/Button";
import BookClosureTable from "../../myfin_v2/elements/BookClosureTable";
import ToggleButton from "../../myfin_v2/elements/ToggleButton";
import Modal from "../../myfin_v2/elements/Modal";
import OpenTaskImg from "../../myfin_v2/assets/imgs/open-tasks.png";
import InProgressImg from "../../myfin_v2/assets/imgs/book-closure-inprogress.png";
import CompletedImg from "../../myfin_v2/assets/imgs/book-closure-completed.png";
import { ReactComponent as DownArrowIcon } from "../../myfin_v2/assets/icons/down-arrow.svg";
import { ReactComponent as FilterIcon } from "../../myfin_v2/assets/icons/filter.svg";
import { ReactComponent as PlusIcon } from "../../myfin_v2/assets/icons/plus.svg";
import { ReactComponent as CloseIcon } from "../../myfin_v2/assets/icons/close.svg";
import { ReactComponent as PlusPrimaryIcon } from "../../myfin_v2/assets/icons/plusprimary.svg";
import { ReactComponent as CommentsActiveIcon } from "../../myfin_v2/assets/icons/comments_active.svg";
import { ReactComponent as CircleCheckIcon } from "../../myfin_v2/assets/icons/circle_check.svg";
import { ReactComponent as DeleteDark } from "../../myfin_v2/assets/icons/delete_dark.svg";
import AddTBModal from "../../myfin_v2/components/bookclosure/AddTBModal";
import UploadTBModal from "../../myfin_v2/components/bookclosure/UploadTBModal";
import PullTBfromERPModal from "../../myfin_v2/components/bookclosure/PullTBfromERPModal";
import BookClosureFilterModal from "../../myfin_v2/components/bookclosure/BookClosureFilterModal";
import RestoreTaskModal from "../../myfin_v2/components/bookclosure/RestoreTaskModal";
import COAModal from "../../myfin_v2/components/bookclosure/SelectCOAModal";
import PaginationFooter from "../../myfin_v2/elements/PaginationFooter";
import { Tooltip } from "../../myfin_v2/elements/Tooltip";
import UploadTbV2 from "./UploadTbV2"

const customStyles = {
    control: (provided, state) => ({
        ...provided,
        borderColor: null,
        boxShadow: state.isFocused ? '0 0 0 1px #E9E9E9' : null,
        '&:hover': {
            borderColor: '#E9E9E9',
        },
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? '#E9E9E9' : state.isFocused ? '#f5f5f5' : 'white',
        color: 'black',
        '&:hover': {
            backgroundColor: state.isSelected ? '#E9E9E9' : '#fefefe',
        },
    }),
};
const customStylesWS = {
    control: (provided) => ({
        ...provided,
        backgroundColor: 'transparent',
        border: 'none',
        boxShadow: 'none',
        minHeight: 'auto',
        paddingLeft: '24px',
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: 'transparent',
        color: 'black',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: '#f0f0f0',
        },
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        position: 'absolute',
        left: 0,
        right: 'auto',
        padding: '0 8px',
        color: '#205A46',
        svg: {
            width: 30,
            height: 30,
        },
    }),

    indicatorSeparator: () => ({
        display: 'none', // Hides the separator line
    }),
    indicatorsContainer: (provided) => ({
        ...provided,
        position: 'absolute',
        left: 0,
        right: 'auto',
        height: '100%',
        pointerEvents: 'none',
    }),
    valueContainer: (provided) => ({
        ...provided,
        paddingLeft: '14px',
        fontSize: "20px"
    }),
    menu: (provided) => ({
        ...provided,
        backgroundColor: 'white',
        border: 'none',
        boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
    }),
};

const Bookclosure = () => {
    const location = useLocation();
    const overviewFilters = location.state?.overviewFilters || null;
    const redirectFilter = location.state?.redirectFilter || null;
    const dispatch = useDispatch();
    const history = useHistory();
    const { workspaceId } = useParams();
    const a = location.pathname;
    const w_id = a.split("/");

    const user = JSON.parse(localStorage.getItem('user'));

    const {
        bookClosureId,
        bookClosureData,
        bookClosureCompanies,
        bookClosureModules,
        BCCompany
    } = useSelector((state) => state.BookClosureReducer);
    const {
        userData
    } = useSelector((state) => state.AuthReducer);

    const [isFieldDialog, setIsFieldDialog] = useState(false);
    const [isAddTaskModal, setIsAddTaskModal] = useState(false);
    const [isTaskAction, setIsTaskAction] = useState(false);
    const [companyId, setCompanyId] = useState("");
    const [addTaskForm, setAddTaskForm] = useState({
        taskId: "",
        companyID: "",
        module: "",
        name: "",
        description: "",
        dueDate: "",
        assigneeID: "",
        approverID: "",
        workingsAndRemarks: "",
        selectedAssignId: [],
        selectedApproverId: {},
        status: "",
        module: "",
        linkedLedgers: [],
        isConfidential: false,
        columns: [],
        bookClosureID:""
    });
    const [LedgersData, setLedgersData] = useState([]);
    const [assetsTags, setAssetsTags] = useState([]);
    const [assetReconcillation, setAssetReconcilllation] = useState([]);
    const [leaseLiabilityReconcillation, setLeaseLiabilityReconcillation] = useState([]);
    const [isLeaseTaskModal, setIsLeaseTaskModal] = useState(false);
    const [isLeaseMonthlyDepFinModal, setIsLeaseMonthlyDepFinModal] = useState(false);
    const [isGLReceivableModal, setIsGLReceivableModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [draggedData, setDraggedData] = useState(null);

    const [displayModal, setDisplayModal] = useState(false);
    const [addTBModal, setAddTBModal] = useState(false);
    const [uploadTBModal, setUploadTBModal] = useState(false);
    const [pullTBfromERPModal, setPullTBfromERPModal] = useState(false);
    const [erpConnections, setErpConnections] = useState([]);
    const [tagLedgers, setTagLedgers] = useState([]);
    const [connectedTasks, setConnectedTasks] = useState([]);
    const [bookClosureFilterModal, setBookClosureFilterModal] = useState(false);
    const [filterAttr, setFilterAttr] = useState(null);
    const [users, setUsers] = useState([]);
    const [paginationParams, setPaginationParams] = useState(null);
    const [addedColumns, setAddedColumns] = useState([]);
    const [taskDetails, setTaskDetails] = useState(null);
    const [addedTBInfo, setAddedTBInfo] = useState(null);
    const [syncWithERPLable, setSyncWithERPLable] = useState("Sync with ERP");
    const [checkReviewed, setCheckReviewed] = useState("N");
    const [prevTaskId, setPrevTaskId] = useState(null);
    const [lastSynced, setLastSynced] = useState(null);
    const [moduleNamesList, setModuleNamesList] = useState([]);
    const [viewMyTasks, setViewMyTasks] = useState(false);
    const [taskAttachmentsForm, setTaskAttachmentsForm] = useState(null);
    const [existingFiles, setExistingFiles] = useState([]);
    const [checklistModules, setChecklistModules] = useState([])
    const [restoreTaskModal, setRestoreTaskModal] = useState(false);
    const [restoreTaskIds, setRestoreTaskIds] = useState([]);
    const [usersData, setUsersData] = useState([]);
    const [bookclosureTags, setBookclosureTags] = useState([]);
    const [appliedFilters, setAppliedFilters] = useState([]);

    const {
        assignOptions,
        approveOptions,
    } = useSelector((state) => state.BookClosureReducer);

    useEffect(() => {
        GetUserData();
        getBookClosureData();
        getTaskOptions();
    }, []);

    const GetUserData = () => {
        if (Object.keys(userData).length === 0) {
            getProfile().then(response => {
                dispatch({ type: "USER_MIDDLEWARE_DATA", payload: response.data?.user?.data ?? {} });
            }).catch(error => {
                swal("Error", error || `User Data Not Found`, 'error');
            })
        }
    }

    const getBookClosureData = (company_id, filters = []) => {

        const data = company_id ? {
            companies: [company_id],
        } : {}

        if (company_id) {
            // Merge all filter objects into one
            const mergedFilters = Object.assign({}, ...filters);

            // Merge into data
            Object.assign(data, mergedFilters);
        }

        setIsLoading(true);
        getOneBookClosure(workspaceId, data).then(response => {
            if (!company_id) {
                console.log("no companyId");

                dispatch({ type: "BOOK_CLOSURE_COMPANIES", payload: response.data.bookClosure?.companyDetails || [] });

                if (overviewFilters) {
                    
                    const { companyIDs, ...otherFilters_ } = overviewFilters;
                    const findCurrentCompany = response.data.bookClosure?.companyDetails.find(company => company._id === companyIDs[0]);
                    dispatch(setBCCompany(findCurrentCompany));
                    setCompanyId(findCurrentCompany._id);
                    const otherFilters = {
                        ...(otherFilters_.modules && { "modules": otherFilters_.modules }),
                        ...(otherFilters_.assigneeIDs && { "assignees": otherFilters_.assigneeIDs }),
                        ...(otherFilters_.approverIDs && { "approvers": otherFilters_.approverIDs }),
                        ...(otherFilters_.dueDates && { "dueDates": [dayjs(otherFilters_.dueDates).format("DD-MM-YYYY")] }),
                        ...(otherFilters_.status && { "statuses": otherFilters_.status })
                    };
                    getBookClosureData(companyIDs[0], [otherFilters]);
                }
                else if (redirectFilter) {
                    
                    const { companyID } = redirectFilter;
                    const findCurrentCompany = response.data.bookClosure?.companyDetails.find(company => company._id === companyID);
                    dispatch(setBCCompany(findCurrentCompany));
                    setCompanyId(findCurrentCompany._id);
                    getBookClosureData(companyID);
                } else {
                    const findCurrentCompany = response.data.bookClosure?.companyDetails[0];
                    dispatch(setBCCompany(findCurrentCompany));
                    setCompanyId(findCurrentCompany._id);
                    getBookClosureData(findCurrentCompany._id);

                }

            } else {

                dispatch({ type: "BOOK_CLOSURE_ID", payload: response.data.bookClosure || {} });
                dispatch({ type: "BOOK_CLOSURE_TASKS", payload: response.data.bookClosure || {} });

                const ledgers = response.data.bookClosure.companyDetails[0]?.ledgers ? response.data.bookClosure.companyDetails[0]?.ledgers : [];
                const tagLedgers_ = ledgers.map(({ ledgerCode, ledgerName }) => ({
                    ledgerCode: ledgerCode,
                    ledgerName: ledgerName
                }));
                const modulenames = response.data.modulesData
                const modulenamesList = modulenames.map((moduleObj) => moduleObj.module);
                setModuleNamesList(modulenamesList)
                setTagLedgers(tagLedgers_);
                setFilterAttr(response.data.bookClosure.filtersData[0].filters)
                setBookClosureFilterModal(false);
                setPaginationParams(response.data.pagination);
                setChecklistModules(response.data?.uniquechecklistModules)

                setAddedColumns(response.data.bookClosure.companyDetails[0].columns);
                if (response.data.bookClosure?.TBs[0]?.requestID) {
                    setAddedTBInfo({
                        "bookClosureID": response.data.bookClosure._id,
                        "companyID": company_id,
                        "requestID": response.data.bookClosure.TBs[0].requestID
                    })
                    if (response.data.bookClosure.TBs[0]?.requestTime) {
                        const parsedDate = dayjs(response.data.bookClosure.TBs[0]?.requestTime);
                        if (parsedDate.isValid()) {
                            setLastSynced(`Last Synced ${parsedDate.format('MMM D [at] h:mm A')}`)
                        } else {
                            setLastSynced(null);
                        }
                    } else {
                        setLastSynced(null);
                    }
                } else {
                    setAddedTBInfo(null);
                    setLastSynced(null);
                }
                // 6853a7e8d9a91da25eacf5e4
                if (overviewFilters?.taskId) {
                    ViewTaskMore(overviewFilters?.taskId)
                }
            }
        }).catch(error => {
            swal("Error", `Book Closure Error: ${error.response?.data?.error}`, 'error');
        }).finally(() => setIsLoading(false))
    }

    const getTaskOptions = () => {
        getApproverUserOptions(workspaceId).then(res => {

            dispatch({ type: "TASK_OPTIONS", payload: res.data || {} });
        }).catch(err => {
            swal("Error", `Error: ${err.response?.data?.error}`, 'error');
        });
    }

    const AddTask = () => {

        const data = {
            module: addTaskForm.module ?? "",
            bookClosureID: bookClosureId,
            companyID: BCCompany._id ?? "",
            name: addTaskForm.name,
            description: addTaskForm.description,
            dueDate: dayjs(addTaskForm.dueDate).format("DD-MM-YYYY"),
            assigneeIDs: addTaskForm.assigneeID,
            approverID: addTaskForm.approverID,
            workingsAndRemarks: addTaskForm.workingsAndRemarks,
            module: addTaskForm.module,
            linkedLedgers: addTaskForm.linkedLedgers,
            isConfidential: addTaskForm.isConfidential ?? false
        }
        // columns: addTaskForm?.columns ?? [],


        if (userData?.responsibilities === "preparer") {
            saveAndSubmitTask(data).then(response => {
                const newTaskId = response.data.bookClosureTask._id;
                const bookClosureID = response.data.bookClosureTask.bookClosureID;
                if (taskAttachmentsForm) {

                    taskAttachmentsForm.set("taskID", newTaskId);
                    taskAttachmentsForm.set("bookclosureID", bookClosureID);

                    updateTaskAttachments(taskAttachmentsForm).catch((err) => {
                        swal(
                            "Error",
                            `Attachments upload failed: ${err.response?.data?.error || err.message}`,
                            "error"
                        );
                    });

                }
                getBookClosureData(companyId);
                handleTaskModalClose();
                // toast.success("Task Save and Submitted Successfully.");
                swal("Success", "Task Save and Submitted Successfully.", 'success')
            }).catch(error => swal("Error", `Error: ${error.response?.data?.error || "Task Return Failed!"}`, 'error'))
        } else {
            addTask(data).then(response => {
                // toast.success("Task added successfully.");
                swal("Success", "Task added successfully.", 'success')
                console.log("newtaskresponse",response.data);
                const newTaskId = response.data.bookClosureTask._id;
                const bookClosureID = response.data.bookClosureTask.bookClosureID;
                if (taskAttachmentsForm) {

                    taskAttachmentsForm.set("taskID", newTaskId);
                    taskAttachmentsForm.set("bookclosureID", bookClosureID);

                    updateTaskAttachments(taskAttachmentsForm).catch((err) => {
                        swal(
                            "Error",
                            `Attachments upload failed: ${err.response?.data?.error || err.message}`,
                            "error"
                        );
                    });
                }
                getBookClosureData(companyId);
                handleTaskModalClose();
            }).catch(error => {
                swal("Error", `Book Closure Error: ${error.response?.data?.error}`, 'error');
            })
        }
    }

    const handleTaskModalClose = () => {
        setAddTaskForm(prev => ({
            ...prev,
            taskId: "",
            module: "",
            companyID: "",
            name: "",
            description: "",
            dueDate: "",
            assigneeID: "",
            approverID: "",
            workingsAndRemarks: "",
            selectedAssignId: [],
            selectedApproverId: {},
            linkedLedgers: [],
            isConfidential: false,
            columns: [],
            bookClosureID: ""
        }));
        setIsLeaseTaskModal(false); // Lease view more modal close
        setIsLeaseMonthlyDepFinModal(false);
        setIsGLReceivableModal(false);
        setIsFieldDialog(false); // close select dialog box 
        setIsAddTaskModal(false); // General task view more modal close
        setIsTaskAction(false); // handle save and update button for general task modal
        dispatch(clearLedgersViewMoreTask())
    }

    const ViewTaskMore = (taskId, checkReview = "N", prevTask = null) => {
        setCheckReviewed(checkReview);
        setPrevTaskId(prevTask);

        setAddTaskForm(prev => ({ ...prev, taskId }));
        getOneTask(taskId).then((response) => {
            if (response.data?.confidential) {
                swal("Confidential Task", response.data?.message, 'warning');
            } else {
                dispatch(setAdjustments([]));
                setConnectedTasks([]);

                setConnectedTasks(response.data.linkedTasks)
                const taskData = response.data.bookClosureTask;
                
                setTaskDetails(taskData);
                setBookclosureTags(response?.data?.bookclosureTags);
                setExistingFiles(taskData.attachments || []);
                setTaskAttachmentsForm(null);
                setUsersData(response.data.usersData)
                const ledgers = response.data?.ledgers || [];
                const addedLedgers = response.data?.addedLedgers || [];
                // setAssetsTags(response.data?.assetTags);
                // setLedgersData(response.data?.ledgers);
                // setAssetReconcilllation(response.data.bookClosureTask?.ROUAssetReconcillation);
                // setLeaseLiabilityReconcillation(response.data.bookClosureTask?.leaseLiabilityReconcillation);

                setAddTaskForm(prev => ({
                    ...prev,
                    name: taskData.name,
                    description: taskData.description,
                    dueDate: taskData?.dueDate ?? "",
                    workingsAndRemarks: taskData.workingsAndRemarks ?? "",
                    selectedAssignId: taskData?.assigneeData ? taskData.assigneeData.map(ele => ({ value: ele._id, label: ele.name })) : [],
                    selectedApproverId: taskData?.approverData ? { value: taskData.approverData._id, label: taskData.approverData.name } : {},
                    assigneeID: taskData?.assigneeIDs ?? [],
                    approverID: taskData?.approverID ?? {},
                    status: taskData?.status,
                    module: taskData?.module,
                    linkedLedgers: taskData?.linkedLedgers ?? [],
                    isConfidential: taskData?.isConfidential ?? false,
                    columns: taskData?.columns ?? [],
                    bookClosureID: taskData.bookClosureID
                }));
                dispatch(getLedgersViewMoreTask(ledgers));
                dispatch(setAddedLedgers(addedLedgers));
                dispatch(setTaskComments(taskData.comments));
                dispatch(setAdjustments(taskData.adjustments));

                if (taskData?.templateCode === "lease004") {
                    setIsLeaseMonthlyDepFinModal(true);

                } else if (taskData?.templateCode === "receivables001") {
                    setIsGLReceivableModal(true);
                } else {
                    setIsTaskAction(true);
                    setIsAddTaskModal(true);
                }
            }

        }).catch((error) => {
            swal("Error", `Error: ${error.response?.data?.error}`, 'error');
        })

    }

    const UpdateTask = () => {

        const data = {
            name: addTaskForm.name,
            description: addTaskForm.description,
            dueDate: dayjs(addTaskForm.dueDate).format("DD-MM-YYYY"),
            assigneeIDs: addTaskForm.assigneeID,
            approverID: addTaskForm.approverID,
            workingsAndRemarks: addTaskForm.workingsAndRemarks,
            linkedLedgers: addTaskForm.linkedLedgers,
            columns: addTaskForm.columns ?? [],
            isConfidential: addTaskForm.isConfidential ?? false
        }
        // if (userData?.responsibilities === "approver" && addTaskForm.status === "submitted") {
        //     approveTask(addTaskForm.taskId, {
        //         workingsAndRemarks: addTaskForm.workingsAndRemarks
        //     }).then(response => {
        //         if (taskAttachmentsForm) {
        //             updateTaskAttachments(taskAttachmentsForm).catch((err) => {
        //                 swal(
        //                     "Error",
        //                     `Attachments upload failed: ${err.response?.data?.error || err.message}`,
        //                     "error"
        //                 );
        //             });
        //         }
        //         getBookClosureData(companyId);
        //         handleTaskModalClose();
        //         // toast.success("Task Approved Successfully.");
        //         swal("Success", "Task Approved Successfully.", 'success')
        //     }).catch(error => swal("Error", `Error: ${error.response?.data?.error || "Task Approve Failed!"}`, 'error'));

        // } else if (userData?.responsibilities === "preparer" && ['open', 'returned'].includes(addTaskForm.status)) {
        //     submitTask(addTaskForm.taskId, {
        //         workingsAndRemarks: addTaskForm.workingsAndRemarks
        //     }).then(response => {
        //         if (taskAttachmentsForm) {
        //             updateTaskAttachments(taskAttachmentsForm).catch((err) => {
        //                 swal(
        //                     "Error",
        //                     `Attachments upload failed: ${err.response?.data?.error || err.message}`,
        //                     "error"
        //                 );
        //             });
        //         }
        //         getBookClosureData(companyId);
        //         handleTaskModalClose();
        //         // toast.success("Task Submitted Successfully.");
        //         swal("Success", "Task Submitted Successfully.", 'success')
        //     }).catch(error => swal("Error", `Error: ${error.response?.data?.error || "Task Submit Failed!"}`, 'error'));
        // } else {

        updateTask(addTaskForm.taskId, data).then(response => {
            if (taskAttachmentsForm) {
                updateTaskAttachments(taskAttachmentsForm).catch((err) => {
                    swal(
                        "Error",
                        `Attachments upload failed: ${err.response?.data?.error || err.message}`,
                        "error"
                    );
                });
            }
            getBookClosureData(companyId);
            handleTaskModalClose();
            // toast.success("Task Saved Successfully.");
            swal("Success", "Task Saved Successfully.", 'success')
        }).catch(error => swal("Error", `Error: ${error.response?.data?.error}`, 'error'));
        // }
    }

    const ReturnTask = () => {
        // if (userData?.responsibilities === "approver" && addTaskForm.status === "submitted") {
            returnTask(addTaskForm.taskId).then(response => {
                getBookClosureData(companyId);
                handleTaskModalClose();
                // toast.success("Task Returned Successfully.");
                swal("Success", "Task Returned Successfully.", 'success')
            }).catch(error => swal("Error", `Error: ${error.response?.data?.error || "Task Return Failed!"}`, 'error'))
        // }
    }

    const ApproveTask = () => {
        // if (userData?.responsibilities === "approver" && addTaskForm.status === "submitted") {
            approveTask(addTaskForm.taskId).then(response => {
                getBookClosureData(companyId);
                handleTaskModalClose();
                // toast.success("Task Returned Successfully.");
                swal("Success", "Task Approved Successfully.", 'success')
            }).catch(error => swal("Error", `Error: ${error.response?.data?.error || "Task Return Failed!"}`, 'error'))
        // }
    }

    const SubmitTask = () => {

        updateTask(addTaskForm.taskId, {
            name: addTaskForm.name,
            description: addTaskForm.description,
            dueDate: dayjs(addTaskForm.dueDate).format("DD-MM-YYYY"),
            assigneeIDs: addTaskForm.assigneeID,
            approverID: addTaskForm.approverID,
            workingsAndRemarks: addTaskForm.workingsAndRemarks,
            linkedLedgers: addTaskForm.linkedLedgers,
            columns: addTaskForm.columns ?? [],
            isConfidential: addTaskForm.isConfidential ?? false
        }).then(() => {

            if (taskAttachmentsForm) {
                updateTaskAttachments(taskAttachmentsForm).catch(err => {
                    swal(
                        "Error",
                        `Attachments upload failed: ${err.response?.data?.error || err.message}`,
                        "error"
                    );
                });
            }

            submitTask(addTaskForm.taskId)
            .then(() => {
                swal("Success", "Task Submitted Successfully.", "success");
            })
            .catch(err => {
                swal("Error", `Submit Failed: ${err.response?.data?.error || err.message}`, "error");
            });
            
            getBookClosureData(companyId);
            handleTaskModalClose();
        }).catch(error => {
            swal("Error", `Update Failed: ${error.response?.data?.error || error.message}`, 'error');
        });
    };


    const DeleteTask = () => {

        deleteTask({taskID:addTaskForm.taskId}).then(response => {
            getBookClosureData(companyId);
            handleTaskModalClose();
        }).catch(error => swal("Error", `Error: ${error.response?.data?.error || "Task Delete Failed!"}`, 'error'))
      
    }

    const RestoreTasks = () => {

        restoreTasks({taskIDs:restoreTaskIds}).then(response => {
            setRestoreTaskModal(false);
            getBookClosureData(companyId);
        }).catch(error => swal("Error", `Error: ${error.response?.data?.error || "Task Restore Failed!"}`, 'error'))
      
    }

    const AddLedgerToTask = (ledgerID) => {
        addLedgerToTask({
            bookClosureID: bookClosureId,
            companyID: companyId,
            taskID: addTaskForm.taskId,
            ledgerID
        }).then(response => {
            // toast.success("Ledger added successfully");
            swal("Success", "Ledger added successfully", 'success')
            dispatch(setIsAddToTackModalOpen(false))
        }).catch(error => swal("Error", `Error: ${error.response?.data?.error || "Ledger Added To Task Failed!"}`, 'error'))
    }

    const UpdateLedgerInTask = (ledgerID, remarks, amount) => {
        updateLedgerInTask({
            bookClosureID: bookClosureId,
            companyID: companyId,
            taskID: addTaskForm.taskId,
            ledgerID,
            remarks,
            amount,
        }).then(response => {
            // toast.success("Ledger Updated Successfully");
            swal("Success", "Ledger Updated Successfully", 'success')
            getOneTask(addTaskForm.taskId).then((response) => {
                const addedLedgers = response.data?.addedLedgers || [];
                dispatch(setIsEditLedgerModal(false));
                dispatch(setAddedLedgers(addedLedgers));
            }).catch((error) => {
                swal("Error", `Error: ${error.response?.data?.error}`, 'error');
            })
        }).catch(error => swal("Error", `Error: ${error.response?.data?.error || "Ledger Added To Task Failed!"}`, 'error'))
    }

    const TbOnClick = () => {
        if (BCCompany?.TBAvailable) {
            const findCurrentTb = bookClosureData.TBs.find(tb => tb.companyID === BCCompany._id);
            history.push(`/tbc/${findCurrentTb._id}/${workspaceId}/${companyId}`);
            // setDisplayModal(true);
            // setAddTBModal(true)
        } else {
            // history.push(`/upload-tb/${workspaceId}/${companyId}`);

            setDisplayModal(true);
            setAddTBModal(true)
        }
    }
    const addNewAsset = () => {
        const newAsset = {
            assetCategory: "",
            ledgers: [],
            registerAssets: [],
            difference: 0,
        };

        setAssetReconcilllation([...assetReconcillation, newAsset]);
    };

    const handleDragStart = (e, ele) => {
        setDraggedData(ele);
    };

    const handleDrop = (e, key, index) => {
        e.preventDefault();
        if (!draggedData) return;
        if ((key === "LedgerValue" && !draggedData.ledgerCode) || (key === "RegisterValue" && !draggedData.assetClass)) {
            swal("Error", "Invalid drop action!", "error");
            return;
        }

        setAssetReconcilllation((prevState) => {
            return prevState.map((item, idx) => {
                if (idx === index) {
                    // Prevent duplicates in the respective column
                    if (key === "LedgerValue") {
                        const isDuplicate = item.ledgers.some(ledger => ledger.ledgerCode === draggedData.ledgerCode);
                        if (isDuplicate) {
                            swal("Warning", "Ledger Code Already Added!", "warning");
                            return item;
                        }
                        return { ...item, ledgers: [...item.ledgers, draggedData] };
                    }

                    if (key === "RegisterValue") {
                        const isDuplicate = item.registerAssets.some(asset => asset.assetClass === draggedData.assetClass);
                        if (isDuplicate) {
                            swal("Warning", "Asset Tag Already Added!", "warning");
                            return item;
                        }
                        return { ...item, registerAssets: [...item.registerAssets, draggedData] };
                    }
                }
                return item;
            });
        });

        setDraggedData(null);
    };

    const handleAssetChange = (index, field, value) => {
        const updatedAssets = [...assetReconcillation];

        // Update assetCategory if field is "assetCategory"
        if (field === "assetCategory") {
            updatedAssets[index].assetCategory = value;
        }

        // Recalculate difference whenever a change occurs
        const totalLedgerValue = updatedAssets[index].ledgers.reduce(
            (sum, ledger) => sum + (ledger.ledgerValue || 0),
            0
        );

        const totalRegisterValue = updatedAssets[index].registerAssets.reduce(
            (sum, asset) => sum + (asset.assetValue || 0),
            0
        );

        updatedAssets[index].difference = Math.abs(totalLedgerValue - totalRegisterValue);

        // Update the state
        setAssetReconcilllation(updatedAssets);
    };

    const HandleSave = () => {
        const newRecords = assetReconcillation.filter(item => !item._id);

        if (newRecords.length === 0) {
            swal("No Data", "There are no new records to save", 'info');
            return;
        }

        const data = {
            assetCategory: newRecords.length > 0 ? newRecords[0].assetCategory : "",
            ledgers: newRecords.flatMap(item => item.ledgers.map(ledger => ({
                ledgerCode: ledger.ledgerCode,
                ledgerValue: ledger.periodBeginingBalance
            }))),
            registerAssets: newRecords.flatMap(item => item.registerAssets.map(asset => ({
                assetClass: asset.assetClass,
                assetValue: asset.assetValue
            })))
        };
        addAssetsReconcillations(addTaskForm.taskId, data).then((response) => {
            swal("Success", "New records saved successfully!", "success");
            getOneTask(addTaskForm.taskId).then((response) => {
                setAssetReconcilllation(response.data.bookClosureTask?.ROUAssetReconcillation);
                setLeaseLiabilityReconcillation(response.data.bookClosureTask?.leaseLiabilityReconcillation);
            }).catch((error) => {
                swal("Error", `Error: ${error.response?.data?.error}`, 'error');
            })
        }).catch((error) => {
            swal("Error", `Error: ${error.response?.data?.error}`, 'error');
        })
    }

    const HandleDelete = (ROUAssetReconcillationID, index) => {
        if (!ROUAssetReconcillationID) {
            const updatedAssetReconcilllation = [...assetReconcillation];
            updatedAssetReconcilllation.splice(index, 1);
            setAssetReconcilllation(updatedAssetReconcilllation);
            return;
        }
        deleteAssetsReconcillations(addTaskForm.taskId, ROUAssetReconcillationID)
            .then((response) => {
                swal("Success", "Records deleted successfully!", "success");
                getOneTask(addTaskForm.taskId)
                    .then((res) => {
                        setAssetReconcilllation(res.data.bookClosureTask?.ROUAssetReconcillation);
                        setLeaseLiabilityReconcillation(res.data.bookClosureTask?.leaseLiabilityReconcillation);
                    })
                    .catch((error) => {
                        swal("Error", `Error: ${error.response?.data?.error}`, "error");
                    });
            })
            .catch((error) => {
                swal("Error", `Error: ${error.response?.data?.error || "Unauthorized"}`, "error");
            });
    };


    const HandleUpdate = (ROUAssetReconcillationID) => {
        const editRecords = assetReconcillation.filter(item => item._id === ROUAssetReconcillationID);

        const data = {
            assetCategory: editRecords.length > 0 ? editRecords[0].assetCategory : "",
            ledgers: editRecords.flatMap(item => item.ledgers.map(ledger => ({
                ledgerCode: ledger.ledgerCode,
                ledgerValue: ledger.periodBeginingBalance
            }))),
            registerAssets: editRecords.flatMap(item => item.registerAssets.map(asset => ({
                assetClass: asset.assetClass,
                assetValue: asset.assetValue
            })))
        };
        updateAssetsReconcillations(addTaskForm.taskId, ROUAssetReconcillationID, data).then((response) => {
            swal("Success", "New records updated successfully!", "success");
            getOneTask(addTaskForm.taskId).then((response) => {
                setAssetReconcilllation(response.data.bookClosureTask?.ROUAssetReconcillation);
                setLeaseLiabilityReconcillation(response.data.bookClosureTask?.leaseLiabilityReconcillation);
            }).catch((error) => {
                swal("Error", `Error: ${error.response?.data?.error}`, 'error');
            })
        }).catch((error) => {
            swal("Error", `Error: ${error.response?.data?.error}`, 'error');
        })
    }


    const importPresets = () => {
        window.location.href = "/myfinv2/book-closure/import-presets";
    };


    const handleClose = () => {
        setDisplayModal(false);
    };

    const addTBFromERP = () => {
        const get_params = { companyId: companyId, status: 'C', reqtype: 'PULL' }
        getERPPullRequests(get_params).then(response => {

            setErpConnections(response.data.erpRequests)

        }).catch(error => {
            // swal("Error", `Error in fetching ERP Pull Connections: ${error.response?.data?.error}`, 'error');
        })
        setPullTBfromERPModal(true)
    }
    const handleAddTbModals = (flag) => {
        if (flag === "close") {
            setDisplayModal(false);
            setAddTBModal(false);
            setUploadTBModal(false);
            setPullTBfromERPModal(false);
        }
    }
    const handleTaskCreation = () => {
        dispatch(setAdjustments([]));
        setConnectedTasks([]);
        setIsAddTaskModal(true);
        dispatch(setTaskComments([]));
        setTaskDetails(null);

    }


    const viewMyTaskHandler = (stat) => {
        setViewMyTasks(stat);
        let filters = [];
        if (stat) {
            filters.push({
            assignees: [user._id], // only add when ON
            });
        }
        // const filters = stat ? [{
        //     assignees: [user._id],
        // }] : []
        getBookClosureData(companyId, filters);

        // const filters = {
        //     taskID: "682467f9de9bc5c0080b5d56",
        //     columnID: "6825572ede9bc5c0080b6188",
        //     value: "Incorrect Adjustments"
        // }

        // getBookClosureAddColumnDataApiHandler(filters)


    }

    const paginationHandler = (paginationEvents) => {
        getBookClosureData(companyId, [paginationEvents]);
    }


    const syncWithERP = (tbInfo) => {

        syncERPData(tbInfo)
            .then((response) => {
                if (
                    response.data.message === "Data synced with ERP") {
                    // toast.success("Sync with ERP successfully.");
                    swal("Success", "Sync with ERP successfully.", 'success')
                    setSyncWithERPLable("Synced");
                } else {
                    // toast.error(response.message);
                    swal(
                        "Error",
                        response?.message || "Sync with ERP Failed",
                        "error"
                    );
                }
            })
            .catch((error) => {
                swal(
                    "Error",
                    error?.response?.data?.error || "Sync with ERP Failed",
                    "error"
                );
            });
    }

    const capitalizeFirstLetter = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1);
    };

    const assigneeMap = Object.fromEntries(assignOptions.map(u => [u.value, u.label]));

    const filterKeyLabels = {
        modules: "Module",
        assignees: "Assignee",
        approvers: "Approver",
        statuses: "Status",
        dueDates: "Due Date",
        dueDate: "Due Date",
        assigneeIDs: "Assignee",
        approverID: "Approver",
        module: "Module",
        status: "Status",
    };

    return (
        <>
            <div className={commoncss.pageLayout}>
                {/* <Navbar /> */}
                <Sidebar />
                <div className={`d-flex ${commoncss.pageContent}`}>
                    <motion.div
                        initial={{ x: -100, opacity: 0 }}
                        animate={{ x: 0, opacity: 1 }}
                        exit={{ x: 100, opacity: 0 }}
                        transition={{ duration: 0.5, ease: "easeInOut" }}
                    >
                        <SideBarv2 w_id={w_id} />
                    </motion.div>
                    {
                        isLoading ? <Loading /> :
                            <div className={bookclosurecss.bookClosureContent} style={{ overflow:"hidden" }}>
                                <div className={bookclosurecss.bookClosureHeader}>
                                    <motion.div
                                        initial={{ y: -100, opacity: 0 }}
                                        animate={{ y: 0, opacity: 1 }}
                                        exit={{ y: 0, opacity: 0 }}
                                        transition={{ duration: 0.5, ease: "easeInOut" }}
                                        className={bookclosurecss.headerContent}>
                                        <div style={{ width: "20rem", "z-index": "100" }}>
                                            {
                                                bookClosureCompanies && bookClosureCompanies.length > 0 &&
                                                <Select
                                                    options={bookClosureCompanies.map((company) => ({
                                                        value: company._id,
                                                        label: company.company_name,
                                                    }))}
                                                    value={bookClosureCompanies.map((company) => ({
                                                        value: company._id,
                                                        label: company.company_name,
                                                    })).find((option) => option.value === companyId)} // Preselect the current value if applicable
                                                    onChange={(selectedOption) => {
                                                        const findCurrentCompany = bookClosureCompanies.find((ele, i) => ele._id === selectedOption.value);
                                                        dispatch(setBCCompany(findCurrentCompany));
                                                        setCompanyId(selectedOption.value);
                                                        getBookClosureData(selectedOption.value);
                                                        setViewMyTasks(false);
                                                    }}
                                                    components={{ DropdownIndicator: DownArrowIcon }}
                                                    styles={customStylesWS}
                                                    isSearchable={false}
                                                />
                                            }
                                        </div>
                                        <div className='d-flex'>
                                            <Button
                                                btnColor={buttoncss.greyBg}
                                                icon={<CommentsActiveIcon />}
                                                label="Comments"
                                                onClick={() => { history.push(`/bookclosure/comments/${workspaceId}/${bookClosureId}/${companyId}`) }}
                                            />&ensp;
                                            <Button
                                                btnColor={buttoncss.greyBg}
                                                label="Import Presets"
                                                isEnabled={user.responsibilities !== "preparer"}
                                                onClick={() => history.push(`/import-preset/${workspaceId}/${companyId}`)}
                                            />&ensp;
                                            <Button
                                                btnColor={buttoncss.primary}
                                                label="Import Tasks"
                                                isEnabled={user.responsibilities !== "preparer"}
                                                onClick={() => history.push(`/bookclosure-library/${workspaceId}/${companyId}`)}
                                            />
                                        </div>
                                    </motion.div>
                                </div>
                                <div className={bookclosurecss.bookClosureData}>
                                    <motion.div
                                        initial={{ y: -100, opacity: 0 }}
                                        animate={{ y: 0, opacity: 1 }}
                                        exit={{ y: 0, opacity: 0 }}
                                        transition={{ duration: 0.5, ease: "easeInOut" }} className={`${commoncss.dFlexJustifysb} w-100`}>
                                        <DisplayCard label="OPEN TASKS" value={bookClosureData?.openTasks ? bookClosureData?.openTasks : 0} image={OpenTaskImg} />
                                        <DisplayCard label="IN PROGRESS" value={bookClosureData?.tasksPendingApproval ? bookClosureData?.tasksPendingApproval : 0} image={InProgressImg} />
                                        <DisplayCard label="COMPLETED" value={`${bookClosureData?.completedTasksPercentage ? bookClosureData?.completedTasksPercentage : 0}%`} image={CompletedImg} />
                                    </motion.div>
                                    <motion.div
                                        initial={{ y: 100, opacity: 0 }}
                                        animate={{ y: 0, opacity: 1 }}
                                        exit={{ y: 0, opacity: 0 }}
                                        transition={{ duration: 0.5, ease: "easeInOut" }} className={bookclosurecss.tableContainerBookClosure}>
                                        <div className={bookclosurecss.filtersHeader}>
                                            <span className={bookclosurecss.bkclTbHeader}>Book Closure Activities</span>
                                            <FilterIcon className={commoncss.clickable} width={20} height={20} onClick={() => { setBookClosureFilterModal(true); setDisplayModal(true); }} />
                                            <span className='px-2'>
                                                <ToggleButton
                                                    label="View my tasks"
                                                    value={viewMyTasks} 
                                                    onToggle={(event) => {
                                                    viewMyTaskHandler(event);
                                                }} />
                                            </span>
                                            {addedTBInfo && (

                                                <Tooltip content={lastSynced} variant="black" position="top" enable={lastSynced ? true : false}>
                                                    <Button
                                                        btnColor={buttoncss.secondary}
                                                        label={syncWithERPLable}
                                                        onClick={() => {
                                                            // console.log("addedTBInfo", addedTBInfo);
                                                            syncWithERP(addedTBInfo);
                                                            //   setDisplayModal(true);
                                                            //   setSuccessMessage("Sync Initiated Successfully");
                                                            //   setSuccessModal(true);
                                                        }}
                                                        icon={syncWithERPLable === "Synced" ? <CircleCheckIcon /> : ""}

                                                    />
                                                </Tooltip>
                                            )}
                                            <Button
                                                btnColor={buttoncss.secondary}
                                                label="View FSCP posting"
                                                onClick={() => {
                                                    history.push(`/bookclosure-entries/${workspaceId}/${companyId}`)
                                                }}
                                            />
                                            <Button
                                                btnColor={buttoncss.secondary}
                                                label={BCCompany?.TBAvailable ? "View TB" : "Add TB"}
                                                onClick={TbOnClick}
                                            />
                                            {(userData?.isAdmin == "Yes" || user?.responsibilities === "approver") && (

                                                <Button
                                                    icon={<PlusIcon />}
                                                    btnColor={buttoncss.primary}
                                                    label="Add task"
                                                    isEnabled={user.responsibilities !== "preparer"}
                                                    onClick={() => setIsFieldDialog(true)}
                                                />
                                            )}
                                            {(userData?.isAdmin == "Yes" || user?.responsibilities === "approver") && (

                                                <div style={{ margin: "0px 5px" ,cursor:"pointer" }}>
                                                    <DeleteDark 
                                                        onClick={() => {
                                                            setDisplayModal(true);
                                                            setRestoreTaskModal(true)
                                                        }}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                        {appliedFilters.some(filterObj => 
                                            filterObj &&
                                                (
                                                    Object.keys(filterObj).some(key => key !== "customFilters") ||
                                                    (filterObj.customFilters && filterObj.customFilters.length > 0)
                                                )
                                            ) && (
                                            <div className={bookclosurecss.appliedFiltersContainer}>
                                                <span style={{ minWidth:"120px" }}> Applied Filters </span>
                                                <div className={bookclosurecss.searchedFiltersContainer}> 
                                                    {appliedFilters
                                                        .filter(filterObj => {
                                                        if (!filterObj) return false;
                                                        if (filterObj.customFilters) return filterObj.customFilters.length > 0;
                                                        return Object.keys(filterObj).length > 0;
                                                    })
                                                    .map((filter, i) => {

                                                        const isBasic = !filter.customFilters;

                                                        if (isBasic) {
                                                            return Object.entries(filter).map(([key, values]) =>
                                                                values.map((val, idx) => {

                                                                    let displayValue = val;

                                                                    if (key === "assignees") displayValue = assigneeMap[val] || val;
                                                                    if (key === "approvers") displayValue = assigneeMap[val] || val;

                                                                    return (
                                                                        <div key={`${i}-${key}-${idx}`} className={bookclosurecss.filterItemBadge}>
                                                                            <span>{`${filterKeyLabels[key] || capitalizeFirstLetter(key)} - `}</span>
                                                                            <span>{displayValue}</span>
                                                                        </div>
                                                                    )
                                                                })
                                                            );
                                                        }


                                                        if (filter.customFilters) {

                                                            return filter.customFilters.map((filt, idx) => {

                                                                let label = filt.key;
                                                                let displayValue = filt.value;

                                                                if (filt.fieldType === "Custom") {
                                                                    const col = addedColumns.find(c => c.columnID === filt.key);
                                                                    label = col?.columnTitle || filt.key;
                                                                }

                                                                if (filt.type === "people") {
                                                                    displayValue = assigneeMap[filt.value] || filt.value;
                                                                }

                                                                if (filt.fieldType === "Default") {
                                                                    label = filterKeyLabels[filt.key] || capitalizeFirstLetter(filt.key);
                                                                }

                                                                return (
                                                                    <div key={`${i}-custom-${idx}`} className={bookclosurecss.filterItemBadge}>
                                                                        <span>{`${label} - ${filt.filterType}- `}</span>
                                                                        <span>{displayValue}</span>
                                                                    </div>
                                                                );
                                                            })

                                                        }

                                                        return null;

                                                    })}  
                                                </div>
                                            </div>
                                        )}
                                        <div>
                                            <BookClosureModuleTasks ViewTaskMore={ViewTaskMore} addedColumns={addedColumns} companyId={companyId} bookClosureId={bookClosureId} getBookClosureData={getBookClosureData} />
                                        </div>
                                    </motion.div>
                                </div>
                                {paginationParams && (
                                    <PaginationFooter paginationParams={paginationParams} paginationHandler={paginationHandler} />
                                )}
                            </div>
                    }
                </div>
            </div>

            <CheckFieldDialog
                isFieldDialog={isFieldDialog}
                setIsFieldDialog={setIsFieldDialog}
                handleTaskCreation={handleTaskCreation}
                onClick={
                    () => history.push(`/bookclosure-library/${workspaceId}/${companyId}`)
                }
            />
            {isAddTaskModal && (
                <AddTaskModal
                    isAddTaskModal={isAddTaskModal}
                    setAddTaskForm={setAddTaskForm}
                    addTaskForm={addTaskForm}
                    AddTask={() => {
                        isTaskAction ? UpdateTask() : AddTask()
                    }}
                    handleTaskModalClose={handleTaskModalClose}
                    ReturnTask={ReturnTask}
                    isTaskAction={isTaskAction}
                    userData={userData}
                    AddLedgerToTask={(ledgerID) => { AddLedgerToTask(ledgerID) }}
                    UpdateLedgerInTask={(ledgerID, remarks, amount) => UpdateLedgerInTask(ledgerID, remarks, amount)}
                    tagLedgers={tagLedgers}
                    connectedTasks={connectedTasks}
                    ViewTaskMore={ViewTaskMore}
                    addedColumns={addedColumns}
                    taskDetails={taskDetails}
                    checkReviewed={checkReviewed}
                    prevTaskId={prevTaskId}
                    moduleNamesList={moduleNamesList}
                    taskAttachmentsForm={taskAttachmentsForm}
                    setTaskAttachmentsForm={setTaskAttachmentsForm}
                    existingFiles={existingFiles}
                    setExistingFiles={setExistingFiles}
                    DeleteTask = {DeleteTask}
                    usersData={usersData}
                    bookclosureTags={bookclosureTags}
                    SubmitTask={SubmitTask}
                    ApproveTask={ApproveTask}
                />
            )}

            {isLeaseMonthlyDepFinModal && (
                <LeaseModal
                    isLeaseMonthlyDepFinModal={isLeaseMonthlyDepFinModal}
                    handleTaskModalClose={handleTaskModalClose}
                    UpdateTask={() => {
                        UpdateTask();
                    }}
                    SaveTask={() => {
                        if (userData?.responsibilities === "approver") {
                            ReturnTask();
                        } else { }
                    }}
                    addTaskForm={addTaskForm}
                    setAddTaskForm={setAddTaskForm}
                    userData={userData}
                    assetsTags={assetsTags}
                    LedgersData={LedgersData}
                    assetReconcillation={assetReconcillation}
                    leaseLiabilityReconcillation={leaseLiabilityReconcillation}
                    handleDragStart={handleDragStart}
                    handleDrop={handleDrop}
                    addNewAsset={addNewAsset}
                    handleAssetChange={handleAssetChange}
                    HandleSave={HandleSave}
                    HandleDelete={HandleDelete}
                    HandleUpdate={HandleUpdate}
                    tagLedgers={tagLedgers}
                    connectedTasks={connectedTasks}
                    ViewTaskMore={ViewTaskMore}
                    addedColumns={addedColumns}
                    taskDetails={taskDetails}
                    checkReviewed={checkReviewed}
                    prevTaskId={prevTaskId}
                />
            )}

            {isGLReceivableModal && (
                <GLReceivableModal
                    isGLReceivableModal={isGLReceivableModal}
                    handleTaskModalClose={handleTaskModalClose}
                    UpdateTask={() => {
                        UpdateTask();
                    }}
                    SaveTask={() => {
                        if (userData?.responsibilities === "approver") {
                            ReturnTask();
                        } else { }
                    }}
                    addTaskForm={addTaskForm}
                    setAddTaskForm={setAddTaskForm}
                    userData={userData}
                    assetsTags={assetsTags}
                    LedgersData={LedgersData}
                    assetReconcillation={assetReconcillation}
                    leaseLiabilityReconcillation={leaseLiabilityReconcillation}
                    handleDragStart={handleDragStart}
                    handleDrop={handleDrop}
                    addNewAsset={addNewAsset}
                    handleAssetChange={handleAssetChange}
                    HandleSave={HandleSave}
                    HandleDelete={HandleDelete}
                    HandleUpdate={HandleUpdate}
                    tagLedgers={tagLedgers}
                    connectedTasks={connectedTasks}
                    ViewTaskMore={ViewTaskMore}
                    addedColumns={addedColumns}
                    taskDetails={taskDetails}
                    checkReviewed={checkReviewed}
                    prevTaskId={prevTaskId}
                />
            )}

            {addTBModal && displayModal && (
                <AddTBModal
                    setUploadTBModal={setUploadTBModal}
                    handleClose={handleClose}
                    setAddTBModal={setAddTBModal}
                    setPullTBfromERPModal={addTBFromERP}
                />
            )}
            {uploadTBModal && displayModal && (
                <UploadTbV2 workspaceId={workspaceId} companyId={companyId} setUploadTBModal={setUploadTBModal} setAddTBModal={setAddTBModal} setDisplayModal={setDisplayModal} />
            )}

            {pullTBfromERPModal && displayModal && (
                <PullTBfromERPModal
                    handleClose={handleClose}
                    setAddTBModal={setAddTBModal}
                    setPullTBfromERPModal={setPullTBfromERPModal}
                    erpConnections={erpConnections}
                    companyId={companyId}
                    bookClosureId={bookClosureId}
                    handleAddTbModals={handleAddTbModals}
                    getBookClosureData={getBookClosureData}
                    workspaceId={workspaceId}
                />
            )}

            {bookClosureFilterModal && displayModal && (
                <BookClosureFilterModal
                    handleClose={handleClose}
                    setBookClosureFilterModal={setBookClosureFilterModal}
                    companyId={companyId}
                    assignOptions={assignOptions}
                    approveOptions={approveOptions}
                    getBookClosureData={getBookClosureData}
                    filterAttr={filterAttr}
                    checklistModules = {checklistModules}
                    setAppliedFilters={setAppliedFilters}
                />
            )}

            {restoreTaskModal && displayModal && (
                <RestoreTaskModal
                    handleClose={handleClose}
                    setRestoreTaskModal={setRestoreTaskModal}
                    restoreTaskIds = {restoreTaskIds}
                    setRestoreTaskIds = {setRestoreTaskIds}
                    RestoreTasks = {RestoreTasks}
                />
            )}
        </>
    );
};

export default Bookclosure;

export const BookClosureButton = ({ className, onClick, children, ...props }) => {
    return (
        <button
            className={`font-size-16 custom-font-500 radius-8px shadow border-0 custom-common-theme-text-color font-sans radius-6px custom-bg-white-150 py-2 ${className}`}
            onClick={onClick}
            {...props}
        >
            {children}
        </button>
    );
};
